import { ToolboxDashboard } from '../interfaces/Organization';

export class MToolboxDashboard{
    public id: number;
    public name: string;
    public url: string;
    public imgUrl: string;
    public active: boolean;
    public allowed: boolean;
    public color: string;
    public description: string;

    constructor(toolbox: ToolboxDashboard){
        this.id = toolbox.id;
        this.name = toolbox.nombre;
        this.url = toolbox.url;
        this.imgUrl = toolbox.image_url;
        this.active = toolbox.activo;
        this.allowed = toolbox.permitido;
        this.color = toolbox.color;
        this.description = toolbox.descripcion;
    }
}
